// MilestoneTypes values, hand-synched w/ PortCall.Models\Schedule\MilestoneType.cs.
export enum MilestoneTypes {
    FirstArrival   = 10,
    FinalDeparture = 20,
    BerthArrival   = 30,
    ShiftDeparture = 40,
};



// WEBPACK FOOTER //
// ./data/models/MilestoneTypes.ts